import {
  RoomDescription,
  roomDescription,
  RoomId,
  roomId,
  RoomStartAt,
  roomStartAt,
  RoomTitle,
  roomTitle
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomUpdate2Cmd {
  private static validation = JsonSchemaValidator.compile(
    RoomUpdate2Cmd.validationSchema()
  );

  constructor(readonly value: RoomUpdate2CmdRaw) {
    JsonSchemaValidator.assert(RoomUpdate2Cmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "roomTitle"],
      properties: {
        roomId,
        roomTitle,
        roomDescription,
        roomStartAt
      },
      additionalProperties: false
    };
  }
}

interface RoomUpdate2CmdRaw {
  roomId: RoomId;
  roomTitle: RoomTitle;
  roomDescription?: RoomDescription;
  roomStartAt?: RoomStartAt;
}
